import { Dropdown, Tooltip } from 'antd'
import React, { useEffect, useState } from 'react'
import ClientDocument from './_ClientDocument';
import { faFolder } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import { CustomerCardModel } from '../../models/CustomerCardModel';
import DeleteAlert from '../../components/DeleteAlert';

interface Props {
    folder: any;
    documentsList: any;
    apiUrl: string;
    displayClientDocument: (file: any) => void;
    fromPolicy?: boolean;
    policyId?: string;
    fromSigning?: boolean;
    loadData: () => void;
    showEditFolderPopUp: (folderId: string) => void;
    showAddTreatmentPopup?: (type: number) => void;

}

const ClientFolderDocuments = (props: Props) => {

    const [open, setOpen] = useState<boolean>(false);
    const [parent, setParent] = useState<boolean>(props.documentsList.length > 0 ? true : false);
    const [warnningDeleteFile, setWarnningDeleteFile] = useState<boolean>(false);


    useEffect(() => {
        setParent(props.documentsList.length > 0 ? true : false);
    }, [props.documentsList.length]);


    useEffect(() => { }, [])

    const editFolder = (folderId: string) => {
        props.showEditFolderPopUp(folderId);
        // Logic to edit folder goes here
        console.log(`Editing folder with ID: ${folderId}`);
    }

    const deleteFolder = async (folderId: string) => {
        // Logic to delete folder goes here
        console.log(`Deleting folder with ID: ${folderId}`);
        if (!folderId) return;
        const resp = await new CustomerCardModel().customerDocumentsDeleteFolder(folderId);
        if (resp) {
            props.loadData();
        } else {
            console.error('Failed to delete folder:', resp);
        }
    }


    const dropdownItems = [

        {
            key: '1',
            label:
                <div className="pointer rtl"
                    onClick={() => { editFolder(props.folder.id) }}
                >
                    ערוך
                </div>,
        },
        {
            key: '2',
            label:
                <div className="pointer rtl"
                    onClick={() =>setWarnningDeleteFile(true)}
                >
                    מחק
                </div>,
        }
    ]

    const onIconClick = () => {
        setOpen(!open);
    }

    const hasPermission = () => {
        const loggerUser = localStorage.getItem('loggedUser');
        if (loggerUser) {
            const user = JSON.parse(loggerUser);
            if (user.role === 0) {
                return dropdownItems
            }
        }
        return [];
    }

    const onAddNewTreatmentClick = (type: number) => {
        if (props.showAddTreatmentPopup) {
            props.showAddTreatmentPopup(type); // 0 for new treatment
        }
    }


    return (
        <div className={`policy-details data-card-row ${open ? 'opened' : ''}`}>
            {warnningDeleteFile && (
                <DeleteAlert
                    show={warnningDeleteFile}
                    onClose={() => setWarnningDeleteFile(false)}
                    onConfirm={async () => {
                        setWarnningDeleteFile(false);
                        await deleteFolder(props.folder.id);
                        await props.loadData()
                    }}
                />
            )}
            <Dropdown menu={{ items: hasPermission() }} trigger={['contextMenu']}>
                <div className="data-card client-details-row client-item" style={{ display: 'flex', gap: '10px', justifyContent: 'flex-start', alignItems: 'center' }}>

                    <div style={{ width: '50px' }}>
                        <div className={`policy-icon-holder on-click-ignore  ${parent ? '' : 'hide'}`}>
                            {parent && open ? (
                                <div className='icon squire-minus pointer' onClick={onIconClick}></div>
                            ) : (<></>)}
                            {parent && !open ? (
                                <div className='icon squire-plus pointer' onClick={onIconClick}></div>
                            ) : (<></>)}
                        </div>
                    </div>


                    <div style={{ width: '170px' }}>
                        <div className='icon-holder'>
                            <FontAwesomeIcon icon={faFolder
                            } />
                        </div>
                        <Tooltip placement="bottom" title={props.folder.name ? props.folder.name : 'תיקייה ללא שם'}>
                            <div className='description cell-value' style={{fontWeight: 'bold'}}>
                                {props.folder.name ? props.folder.name : 'תיקייה ללא שם'}
                            </div>
                        </Tooltip>

                    </div>
                    <div style={{ width: '250px' }}>
                        <div className="cell empty">

                        </div>
                    </div>
                    <div style={props.fromSigning === true ? { display: 'none' } : { width: '170px' }}>
                        <div className="cell empty">

                        </div>
                    </div>
                    <div style={props.fromSigning === true ? { display: 'none' } : { width: '170px' }}>
                        <div className="cell empty">

                        </div>
                    </div>
                    <div style={{ width: '170px' }}>
                        <div className="cell empty">

                        </div>
                    </div>
                    <div style={{ width: '170px' }}>
                        <div className="description cell-value">
                        </div>
                    </div>
                    <div style={{ width: '170px' }}>
                        <div className="cell empty">
                            {moment(props.folder.createdDate).format('DD-MM-YYYY')}

                        </div>
                    </div>
                    <div style={{ width: '170px' }}>
                        <Dropdown menu={{ items: hasPermission() }}>
                            <div className="act-btn-icon icon menu-hamburger pointer"></div>
                        </Dropdown>
                    </div>

                </div>
            </Dropdown>
            <div className={`${open ? '' : 'hide'}`}>
                {props.documentsList ? (<>
                    {props.documentsList.map((document: any) => {
                        return (
                            <>
                                <ClientDocument
                                    documentDetails={props.fromPolicy ? document.customerDocument : document}
                                    config={{
                                        apiUrl: props.apiUrl,
                                        displayFile: props.displayClientDocument ? props.displayClientDocument : (fileUrl: any) => { },
                                    }}
                                    loadData={props.loadData}
                                    fromPolicy={props.fromPolicy}
                                    policyId={props.policyId}
                                    fromSigning={props.fromSigning}
                                    showAddTreatmentPopup={(type: number) => onAddNewTreatmentClick(type)}
                                />
                            </>
                        )
                    })}
                </>) : (<></>)}

            </div>
        </div>
    )
}

export default ClientFolderDocuments